module.exports = __webpack_public_path__ + "42920a03499070f395ff91ec090734e0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/rainbow-hot-air-balloon.png
// module id = 577
// module chunks = 0